import request from "../base";
const path = "/api/data/ad-accounts";

export default {
  getByFbId: function (fbId) {
    return request().get(path + "/by-fb-id", {
      params: {
        fb_id: fbId
      }
    });
  },
  get: function (params) {
    return request().post(path + "/", params);
  },
  import: function({attachments, template, delimiter, accounts, tags}) {
    let data = new FormData();

    if (attachments && attachments.length > 0) {
      attachments.forEach(attachment => {
        data.append('attachments', attachment);
      });
      data.append('type', 'file');
      data.append('template', template);
      data.append('delimiter', delimiter || '|');

      if (tags) {
        tags.forEach(tag => {
          data.append('tags', tag);
        });
      }
    } else {
      data = {
        type: 'json',
        accounts: accounts,
        tags
      }
    }
  
    return request().post(path + "/method/import", data);
  },
  export: function(params) {
    return request().post(path + "/method/export", params, {
      responseType: 'blob'
    });
  },
  delete: function(filter) {
    return request().delete(path + "/", {
      data: filter
    });
  },
};
